import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment} from '../../environments/environment';
import { UserService} from '../services/user.service';
import { Observable } from 'rxjs';

@Injectable()
export class WebsocketService {
  connection$: WebSocketSubject<any>;

  constructor(private userService:UserService) {}

  connect(){
    if (!this.connection$ || this.connection$.closed) {
      this.connection$ = this.getNewWebSocket();
      this.connection$.subscribe(
        msg => {
//          console.log(msg);
          if(msg.idDevice){
            this.userService.addMarker(msg);
            this.userService.updatePosition(msg);
          }
        },
        // Called whenever there is a message from the server
        err => console.log(err),
        // Called if WebSocket API signals some kind of error
        () => console.log('complete')
        // Called when connection is closed (for whatever reason)
      );
    }
  }

  private getNewWebSocket() {
    return webSocket({
      url: environment.wssEndpoint,
      closeObserver: {
        next: () => {
          console.log('connection closed');
        }
      },
    });
  }

  send(data: any): void {
    if (this.connection$) {
      this.connection$.next(data);
    } else {
      console.log('Did not send data, unable to open connection');
    }
  }

  closeConnection(): void {
    if (this.connection$) {
      this.connection$.complete();
      this.connection$= null;
    }
  }

  ngOnDestroy() {
    this.closeConnection();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/websocket.service.ts